import { render, staticRenderFns } from "./ModalReportName.vue?vue&type=template&id=db52d742"
import script from "./ModalReportName.vue?vue&type=script&lang=js"
export * from "./ModalReportName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports